<dialog
  #dialog
  qai-dialog
  class="edit-simulation-tags-dialog"
  [heading]="'simulationBuilder.EDIT_SIMULATION_TAGS_TITLE' | transloco"
  [description]="''"
  (afterClose)="handleClose()"
  (closeButtonClicked)="handleClose()"
>
  <qai-field
    [label]="'simulationBuilder.TAGS_LABEL' | transloco"
    [error]="tagError"
    class="tags-field"
    [class.is-disabled]="isSaving"
  >
    <qai-multiselect
      #tagsSelect
      [options]="tagOptions"
      [value]="selectedTagUuids"
      [placeholder]="''"
      [persistSearch]="true"
      [disabled]="isSaving"
      (valueChange)="onTagsChange($event)"
      (searchChange)="tagError = undefined"
    >
      <ng-template #dropdownHeader let-term>
        @if (canCreateTag(term)) {
          <button
            qai-menuitem
            type="button"
            [label]="'simulationBuilder.CREATE_TAG_OPTION' | transloco: { term: term.trim() }"
            [disabled]="isCreatingTag"
            (click)="onCreateTag(term)"
          >
            <qai-icon kind="plus" positionStart />
          </button>
        }
      </ng-template>
    </qai-multiselect>
  </qai-field>

  <div class="modal-actions">
    <button
      qai-button
      kind="secondary"
      size="medium"
      type="button"
      [disabled]="isSaving"
      (click)="handleClose()"
    >
      {{ 'simulationBuilder.CLOSE_BUTTON' | transloco }}
    </button>
    <button
      qai-button
      kind="primary"
      size="medium"
      type="button"
      [disabled]="isSaving"
      (click)="handleSave()"
    >
      {{ 'simulationBuilder.SAVE_TAGS_BUTTON' | transloco }}
    </button>
  </div>
</dialog>
